import React, { useState } from 'react';
import { featuredStores, storePresence } from '../data/mock';
import { MapPin, Search, Store } from 'lucide-react';
import { Input } from '../components/ui/input';

const Stores = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredStores = featuredStores.filter(store =>
    store.city.toLowerCase().includes(searchQuery.toLowerCase()) ||
    store.state.toLowerCase().includes(searchQuery.toLowerCase()) ||
    store.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              190+ Stores Across India
            </h1>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '40px'
            }}>
              Discover Care Pharmacy presence nationwide. Quality medicines, professional service, and everyday savings at a store near you.
            </p>

            {/* Search Bar */}
            <div style={{ maxWidth: '500px', margin: '0 auto', position: 'relative' }}>
              <Search size={20} style={{
                position: 'absolute',
                left: '16px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--text-secondary)'
              }} />
              <Input
                type="text"
                placeholder="Search by city or state..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  paddingLeft: '48px',
                  height: '56px',
                  fontSize: '16px',
                  border: '1px solid var(--border-medium)',
                  borderRadius: '0px'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Map Presence Section */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '24px', textAlign: 'center' }}>
            Our Nationwide Presence
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '60px',
            textAlign: 'center',
            maxWidth: '700px',
            margin: '0 auto 60px'
          }}>
            Care Pharmacy has expanded to 190+ locations across 12+ states, serving millions of customers with quality healthcare.
          </p>

          {/* State-wise Store Count */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '24px'
          }}>
            {storePresence.map((region, index) => (
              <div key={index} className="hover-lift" style={{
                padding: '32px',
                background: 'var(--bg-primary)',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}>
                <MapPin size={32} style={{
                  color: index % 2 === 0 ? 'var(--brand-blue)' : 'var(--brand-green)',
                  marginBottom: '16px',
                  display: 'inline-block'
                }} />
                <h3 className="heading-2" style={{ marginBottom: '8px' }}>
                  {region.state}
                </h3>
                <div style={{
                  fontSize: '36px',
                  fontWeight: '300',
                  color: index % 2 === 0 ? 'var(--brand-blue)' : 'var(--brand-green)',
                  marginBottom: '12px'
                }}>
                  {region.count}+
                </div>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {region.cities.join(', ')}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Care Pharmacy Stores */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '24px', textAlign: 'center' }}>
            Featured Care Pharmacy Outlets
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '60px',
            textAlign: 'center',
            maxWidth: '700px',
            margin: '0 auto 60px'
          }}>
            Visit our flagship Care Pharmacy stores for the complete healthcare experience.
          </p>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
            gap: '24px'
          }}>
            {filteredStores.length > 0 ? (
              filteredStores.map((store) => (
                <div
                  key={store.id}
                  className="hover-lift"
                  style={{
                    padding: '32px',
                    background: 'var(--bg-secondary)',
                    borderRadius: '0px',
                    border: '1px solid var(--border-light)'
                  }}
                >
                  <Store size={28} style={{
                    color: 'var(--brand-blue)',
                    marginBottom: '16px'
                  }} />
                  <h3 className="heading-3" style={{ marginBottom: '8px' }}>
                    {store.name}
                  </h3>
                  <div style={{
                    display: 'inline-block',
                    padding: '4px 12px',
                    background: 'var(--bg-primary)',
                    marginBottom: '12px',
                    fontSize: '12px',
                    color: 'var(--brand-green)',
                    fontWeight: '500'
                  }}>
                    {store.state}
                  </div>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '8px' }}>
                    {store.location}, {store.city}
                  </p>
                </div>
              ))
            ) : (
              <div style={{
                gridColumn: '1 / -1',
                textAlign: 'center',
                padding: '60px 20px'
              }}>
                <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
                  No stores found matching your search. Please try different keywords.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            textAlign: 'center',
            padding: '60px 40px',
            background: 'var(--bg-primary)',
            borderRadius: '0px'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Can't Find Your Nearest Store?
            </h2>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '32px'
            }}>
              Contact us for store information, home delivery, or franchise opportunities in your area.
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="tel:+916358585323" className="btn-primary">
                Call +91-6358585323
              </a>
              <a href="https://wa.me/918200886945" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Stores;